import * as React from "react";
import * as S from "@styled";
import { ValidationError } from "../model/ValidationData";

export const ParametersErrorList: React.FC<ErrorProps> = (props) => {

    const errors = props.validationErrors && props.validationErrors.map((error, index) => {
        const errorMessage = error.elementId === props.id ? error.getMessageString() : "";
        if (errorMessage !== "") {
            return <div key={props.id + "_validationError_" + (index)} className="alert alert-warning">{errorMessage}</div>;
        }
    });

    return (
        <div>
            {errors ? <S.ErrorContainer>{errors}</S.ErrorContainer> : null}
        </div>
    );
};

interface ErrorProps {
    id: string;
    validationErrors: ValidationError[];
}
